import clsx from "clsx";
import React, { ReactNode } from "react";

export interface CardProps {
  children?: ReactNode;
  className?: string;
  rounded?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className,
  rounded = true,
}) => {
  return (
    <div
      className={clsx(
        "border-primary-12/10 bg-primary-1/60 dark:border-primary-1 dark:bg-primary-4/70 border transition-colors duration-300",
        className,
        { rounded: rounded },
      )}
    >
      {children}
    </div>
  );
};
